import { StockIndicatorHelpers, StockIndicatorTypes } from '@grandvision/inventory'

type StockResolverFactory = () => StockIndicatorTypes.StockResolver

export const stockResolverFactory: StockResolverFactory = () => {
  return (allowBackOrder, stockCount, thresholds) => {
    // allowing custom logic here
    return StockIndicatorHelpers.defaultStockResolver(allowBackOrder, stockCount, thresholds)
  }
}
